const chimneyDetailedRateCard = {
  key: "chimney",
  title: "Chimney Detailed Rate Card",
  note:
    "Indicative chimney pricing. Final charge depends on oil buildup, chimney size, motor condition, and access.",
  sections: [
    {
      title: "Service",
      items: [
        { name: "Chimney deep cleaning", price: "₹699 onwards" },
        { name: "Filter cleaning / support", price: "₹399 onwards" },
      ],
    },
    {
      title: "Inspection",
      items: [
        { name: "Suction issue inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "Chimney installation support", price: "₹999 onwards" },
      ],
    },
  ],
};

export default chimneyDetailedRateCard;